// This is for algolia. This can be removed in algoliasearch v4.
// Only define it in the browser; under Node (unit tests) the real `process` must stay intact.
(window as any).process ??= {
	env: { DEBUG: undefined },
};
